export default "__VITE_ASSET__DjjS0zBZ__"